"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningComponent = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../gen-src/Localize");
var DialogStyles_1 = require("./styles/DialogStyles");
var WarningComponent = /** @class */ (function (_super) {
    __extends(WarningComponent, _super);
    function WarningComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WarningComponent.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("p", null, Localize_1.Messages.LargeDatasourceWarning()),
            React.createElement("div", { className: DialogStyles_1.DialogStyles.BottomButtons },
                React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, onClick: this.props.handleDismissWarning, testId: "ce-datasource-warning-dismiss-button", children: Localize_1.Messages.DismissLargeDatasourceButtonLabel() }),
                this.renderPublishDatasourceButton())));
    };
    WarningComponent.prototype.renderPublishDatasourceButton = function () {
        var _this = this;
        return !this.props.handlePublishDatasources ? null : (React.createElement(widgets_1.ButtonWidget, { className: DialogStyles_1.DialogStyles.PrimaryButton, buttonType: widgets_1.ButtonType.Primary, onClick: function () { var _a, _b; return (_b = (_a = _this.props).handlePublishDatasources) === null || _b === void 0 ? void 0 : _b.call(_a); }, testId: "ce-datasource-warning-publish-button", children: Localize_1.Messages.PublishDatasourcesButtonLabel() }));
    };
    return WarningComponent;
}(React.PureComponent));
exports.WarningComponent = WarningComponent;
//# sourceMappingURL=WarningComponent.js.map